export default __webpack_public_path__ + "static/media/Chantix 1.044254fe.png";